import { unwrap, withSignal } from "@nexxt/api-client";
import { filterQuery } from "@nexxt/app-kit";
import type { LogisticsClient } from "@nexxt/logistics-ui";
import { api } from "./api";

// The vendor return screens on gateway-atelier (ADR-227 point 11, ADR-229): one call per operation, input and answer
// of its contract. The gateway has the supplier's operations alone (ExternalLogisticsService), and the domain keeps
// every one of them to the returns of the user's organization (RLS on `supplier_org_id`).

const returns = api.logistics["vendor-returns"];
const byId = returns[":vendorReturnId"];

export const logisticsClient: LogisticsClient = {
  listVendorReturns: (input, signal) => unwrap(returns.$get({ query: filterQuery(input) }, withSignal(signal))),
  getVendorReturn: (param, signal) => unwrap(byId.$get({ param }, withSignal(signal))),
  confirmVendorReturn: ({ vendorReturnId, version }) =>
    unwrap(byId.confirm.$post({ param: { vendorReturnId }, json: { version } })),
  refuseVendorReturn: ({ vendorReturnId, ...json }) => unwrap(byId.refuse.$post({ param: { vendorReturnId }, json })),
};
